import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './views/login/login.component';
import { authGuard } from './services/auth/auth.guard';
import { RegisterComponent } from './views/register/register.component';
import { TechsureLmsComponent } from './views/techsure-lms/techsure-lms.component';
import { AssessmentsComponent } from './views/techsure-lms/assessments/assessments.component';
import { TechsureQueriesComponent } from './views/techsure-lms/techsure-queries/techsure-queries.component';
import { TakeAssessmentComponent } from './views/techsure-lms/take-assessment/take-assessment.component';
import { AssessmentSummaryComponent } from './views/techsure-lms/assessment-summary/assessment-summary.component';
import { TrainingVideosComponent } from './views/techsure-lms/training-videos/training-videos.component'; // Ensure path matches where you generated it
import { WatchVideoComponent } from './views/techsure-lms/watch-video/watch-video.component';

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'home', redirectTo: 'vigi/product-queries' },
    { path: 'login', component: LoginComponent},
    { path: 'register', component: RegisterComponent},
    {
      path: 'vigi',
      loadChildren: () =>
        import('./views/vigi/vigi.module').then((m) => m.VigiModule),
      canActivate: [authGuard]
    },
    { 
      path: 'techsure', 
      component: TechsureLmsComponent, 
      canActivate: [authGuard],
      children: [
        { path: '', redirectTo: 'assessments', pathMatch: 'full' },
        { path: 'assessments', component: AssessmentsComponent },
        { path: 'videos', component: TrainingVideosComponent }, // Added videos tab
        { path: 'queries', component: TechsureQueriesComponent },
        { path: 'take/:key', component: TakeAssessmentComponent },
        { path: 'results/:id', component: AssessmentSummaryComponent },
        { path: 'watch', component: WatchVideoComponent },
      ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }